





















































import Vue from 'vue';
import VariableInput from '@/components/util/VariableInput.vue';

export interface CardFormResult {
  message?: string;
  cardForm?: {  cardToken: string, cardSaveFlg?: boolean, }; 
}

export default Vue.extend({
  name: 'PaymentForm',
  components: {
    VariableInput,
  },
  props: {
    showCardSave: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      card: {
        card_no: '',
        expire: '',
        security_code: '',
        holder_name: '',
        number: 1
      },
      cardForm: {
        cardName: '',
        cardToken: '',
        cardSaveFlg: true,
      },
      numberElement: null as any,
    }
  },
  mounted() {
    this.createCardFrom();

    const cardNumberInput = document.querySelector('#card-number-input input') as HTMLInputElement;
    cardNumberInput.addEventListener('input', () => {
      cardNumberInput.value = cardNumberInput.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
    });

    const cardExpireInput = document.querySelector('#card-expire-input input') as HTMLInputElement;
    cardExpireInput.addEventListener("input", () => {
      const inputValue = cardExpireInput.value;
      if (inputValue.length === 2) {
        cardExpireInput.value = inputValue + " / ";
      }
    });
  },
  methods: {
    createCardFrom() {
      if(this.$fincode == null){
        Vue.prototype.$fincode = window.Fincode(process.env.VUE_APP_FINCODE_PUBLIC_KEY);
      }
    },
    async validation(): Promise<CardFormResult> {
      const form = this.cardForm;
      const cardNameRegExp = /[^A-Z\s]+/;
      // カード名義
      if(!this.card.holder_name.trim()){
        return { message: 'カード名義を入力してください' };
      }
      if(this.card.holder_name.match(cardNameRegExp)){
        return { message: 'カード名義を大文字英字で入力してください' };
      }
      // カード番号整形
      const card_no = this.card.card_no.replace(/\D/g, "");
      // 有効期限整形
      var expire = this.card.expire.replace(/\D/g, "");
      expire = expire.slice(2) + expire.slice(0, 2);

      const card = {
        card_no: card_no,
        expire: expire,
        security_code: this.card.security_code,
        holder_name: this.card.holder_name,
        number: this.card.number
      }
      //トークン発行
      const response = await new Promise<{ list: { token: string }[] }>((resolve, reject) => {
        this.$fincode.tokens(card, function(status: any, response: any) {
          if (status === 200) {
            resolve(response);
          } else {
            reject(response);
          }
        });
      }).catch((e) => {
        console.log(e);
      });
      if (response && response.list) {
        this.cardForm.cardToken = response.list[0].token;
      }
      const { cardName, ...rest } = form;
      if(this.showCardSave){
        return { cardForm: rest };
      } else {
        return { cardForm: { cardToken: form.cardToken } };
      }
    },
  },
})
